import React from "react";
import Reveal from "../Reveal";

export const PortfolioColumn = ({ col }) => (
  <Reveal>
    <div className="bg-white rounded-sm p-8 h-full shadow-[0_16px_40px_-28px_rgba(58,55,54,0.35)]">
      <h3 className="font-sans-el tracking-[0.2em] uppercase text-[#6f5f62] text-sm mb-6">
        {col.heading}
      </h3>
      <ul className="space-y-5">
        {col.items.map(([name, desc]) => (
          <li key={name}>
            <span className="font-serif-el text-xl text-[#3a3736]">{name}</span>
            <p className="font-sans-el text-[#5a5552] leading-relaxed mt-1">{desc}</p>
          </li>
        ))}
      </ul>
    </div>
  </Reveal>
);

export const ContactCard = ({ contact }) => (
  <Reveal>
    <div className="bg-[#f6f2ed] rounded-sm p-8 h-full">
      <h3 className="brand-title text-3xl text-[#3a3736] uppercase">{contact.name}</h3>
      <p className="font-sans-el text-sm tracking-wide text-[#6f5f62] mt-2 mb-5">{contact.role}</p>
      <ul className="space-y-2">
        {contact.lines.map((line) => (
          <li key={line} className="font-sans-el text-[#4a4644]">{line}</li>
        ))}
      </ul>
    </div>
  </Reveal>
);
